import capitalize from "lodash/capitalize";
import CustomButton from "rivals/components/shared/CustomButton";
import XLogoIcon from "rivals/components/shared/Icons/XLogoIcon";
import { SOCIAL_MEDIA } from "rivals/shared/constants";
import { setData } from "rivals/shared/utils/qa";
import strings from "./strings";
import { Props } from "./types";

const { dimensions, configs, newWindow, philter } = strings;

const getFacebookUrl = (facebookShare: string, pageUrl: string): string =>
  `${facebookShare}${pageUrl}`;

const getRedditUrl = (
  redditShare: string,
  pageUrl: string,
  socialMediaText: string
): string =>
  `${redditShare}${pageUrl}${socialMediaText && `&title=${socialMediaText}`}`;

const getTwitterUrl = (
  twitterShare: string,
  pageUrl: string,
  socialMediaText: string
): string =>
  `${twitterShare}${pageUrl}${socialMediaText && `&text=${socialMediaText}`}`;

const mapSocialMediaToGetUrl = {
  [SOCIAL_MEDIA.FACEBOOK]: getFacebookUrl,
  [SOCIAL_MEDIA.REDDIT]: getRedditUrl,
  [SOCIAL_MEDIA.TWITTER]: getTwitterUrl
};

const SocialMediaShareIcon = ({
  className = "",
  onClickAnySocialMediaIcon,
  pageUrl,
  socialMedia,
  iconStyle,
  text,
  theme = "light",
  iconOverride
}: Props): JSX.Element => {
  const { icon, shareUrl } = configs[socialMedia];
  const getUrl = mapSocialMediaToGetUrl[socialMedia];
  const url = getUrl(shareUrl, pageUrl, text);

  const graphic =
    socialMedia === "TWITTER" ? (
      <XLogoIcon
        fill={theme === "dark" ? "white" : "black"}
        style={iconStyle}
        {...setData(philter, socialMedia.toLowerCase())}
      />
    ) : (
      <img
        alt={`${socialMedia} logo`}
        src={icon}
        style={iconStyle}
        title={capitalize(socialMedia)}
        {...setData(philter, socialMedia.toLowerCase())}
      />
    );

  return (
    <CustomButton
      ariaLabel={`share on ${socialMedia}`.toLowerCase()}
      className={className}
      icon={iconOverride || graphic}
      onClick={(e): void => {
        e?.preventDefault();
        e?.stopPropagation();
        window.open(url, newWindow, dimensions);
        onClickAnySocialMediaIcon &&
          onClickAnySocialMediaIcon(socialMedia.toLowerCase());
      }}
      philter={socialMedia}
    />
  );
};

export default SocialMediaShareIcon;
